import type React from 'react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import type { OperatingStationOption } from '@/hooks/useOperatingStations'

import { SearchableSelect, type SearchableSelectOption } from './SearchableSelect'

interface StationAutocompleteProps {
  id?: string
  name?: string
  value: string
  stations: OperatingStationOption[]
  isLoading?: boolean
  disabled?: boolean
  className?: string
  inputClassName?: string
  onChange: (stationCode: string) => void
}

export const StationAutocomplete: React.FC<StationAutocompleteProps> = ({
  id,
  name,
  value,
  stations,
  isLoading = false,
  disabled = false,
  className,
  inputClassName,
  onChange,
}) => {
  const { t } = useTranslation()

  const options = useMemo<SearchableSelectOption[]>(
    () =>
      stations.map((station) => ({
        id: station.code,
        value: station.code,
        label: `${station.code} - ${station.name}`,
      })),
    [stations]
  )

  return (
    <SearchableSelect
      id={id}
      name={name}
      selectedValue={value}
      options={options}
      onChange={(option) => onChange(option.value)}
      placeholder={t('dashboard.station')}
      className={className}
      inputClassName={inputClassName}
      disabled={disabled || isLoading || stations.length === 0}
      isLoading={isLoading}
      loadingText={t('nav.loadingStations')}
      emptyText={t('nav.noStations')}
      errorText={t('nav.noStations')}
    />
  )
}
